export const STH_CONFIG = {
  UI: {
    CARD_WIDTH: 220,
    CARD_GAP: 8,
    MIN_CARDS_PER_ROW: 3,
    CONTAINER_DEFAULT_WIDTH: 1200,
  },
  MAP: {
    ZOOM_DEFAULT: 1,
    ZOOM_MIN: 1,
    ZOOM_MAX: 10,
    EURO_COUNTRIES: ['UK', 'Sweden', 'Norway', 'Poland', 'Germany'],
    CDN_URL: 'https://ogdb-cdn.intlgame.cn/front/static/world.json',
  },
  ANIMATION: {
    DURATION: 300,
  },
  COLORS: {
    SURVIVAL: '#F17C86',
    GROWING: '#69D19C',
    EVERGREEN: '#5086F3',
  },
};

export const BADGE_CACHE_TTL = 1 * 60 * 60 * 1000;
export const BADGE_CACHE_MAX_SIZE = 100;
export const MAP_CACHE_TTL = 1 * 60 * 60 * 1000;
